import { useEffect, useRef } from 'react';
import { useAbsences } from '../contexts/AbsencesContext';
import { useOnCalls } from '../contexts/OnCallsContext';
import { useSkills } from '../contexts/SkillsContext';
import { useTechnicians } from '../contexts/TechniciansContext';
import { useAuth } from '../context/AuthContext';

/**
 * Hook pour initialiser tous les contextes après une connexion utilisateur
 */
export const useContextInitializer = () => {
  const { initializeData: initAbsences } = useAbsences();
  const { initializeData: initOnCalls } = useOnCalls();
  const { initializeData: initSkills } = useSkills();
  const { initializeData: initTechnicians } = useTechnicians();
  const { currentUser } = useAuth();
  
  // Flag pour éviter les initialisations multiples
  const hasInitialized = useRef(false);

  useEffect(() => {
    // Ne plus initialiser automatiquement les contextes
    // L'initialisation se fera uniquement via l'événement teamChanged
    // déclenché par TeamContext après sélection de l'équipe
    
    console.log('🚀 ContextInitializer - Utilisateur connecté:', currentUser?.email, '- Attente de la sélection d\'équipe');
  }, [currentUser?.id]);

  // Reset hasInitialized when user changes or disconnects
  useEffect(() => {
    if (!currentUser?.id) {
      hasInitialized.current = false;
    }
  }, [currentUser]);
};

/**
 * Composant pour initialiser tous les contextes après une connexion utilisateur
 * Ce composant doit être rendu APRÈS tous les providers
 */
export const ContextInitializer = () => {
  useContextInitializer();
  return null;
}; 